import React, { Component } from 'react';
import {Provider} from 'react-redux';
import store from './utilities/storage/store';
// import "bootstrap-css-only/css/bootstrap.min.css";
import MainComponent from './components/MainComponent';
import { Router } from './utilities/routing';
import "./App.css"

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router 
        // basename={'/client'}
        >
         <MainComponent/>
        </Router>
      </Provider>
    );
  }
}


export default App;
